/**
 * Build identity — GENERATED by scripts/stamp-version.mjs. Do not edit.
 *
 * Typed as `string`, not left to inference. Without the annotation TypeScript
 * narrows each constant to the literal from whichever build ran last, and any
 * comparison against another value — `COMMIT === 'dev'` in lib/update.ts — is
 * then reported as an impossible overlap. The value genuinely varies per build;
 * the literal type is a lie that only holds until the next commit.
 */
export const VERSION: string = '0.1.0'
export const COMMIT: string = '4d05910'
export const BUILT_AT: number = 1789775599171
